import axios from 'axios';
import path from '../../path';

export const loginApi = (data) => {
    return axios.post(`${path}/v1/doctors/login`, { data });
  };

export const signUpApi = (data) => {
    return axios.post(`${path}/v1/doctors/signup`, { data });
  };

export const signupProviderApi = (data, providerId) => {
    return axios.put(`${path}/v1/provider/signup/${providerId}`, { data });
  };

export const emailVerificationApi = (data) => {
    return axios.post(`${path}/v1/doctors/resend-link`, { data });
  };

export const emailVerifiedGreetingApi = (otpId) => {
    return axios.put(`${path}/v1/doctors/auth-link`, { data: otpId });
  };

export const forgotPasswordApi = (data) => {
    return axios.post(`${path}/v1/user/forget-password`, { data });
  };

export const setPasswordApi = (data,token) => {
    return axios.put(`${path}/v1/user/set-password/${token}`, { data },{
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  };


 